module.exports = __webpack_public_path__ + "media/images/product-page-card-default-7337694d.jpg";